<template>
    <modal
      id="response-modal"
      v-if="proposal.id"
      :show="proposal.id"
      :closeOnbackdrop="false"
      @close="handleClose">
        <template slot="header">
            <h4 style="color: white;">Notes for {{ proposal.quote_number }} <span v-if="proposal.response_code">({{ proposal.response_code }})</span></h4>
        </template>
        <template>
          <form
            ref="responseCodeForm"
            class="response-code-form"
            autocomplete="off"
            @submit.prevent="handleClickSave">
            <div class="row">
                <div class="col-md-12">
                    <div class="row">
                        <div class="form-group col-md-12 col-xs-12 col-lg-12">
                            <label>Bid:</label>
                            <select
                              ref="project_awarded"
                              v-model="selected.project_awarded"
                              :class="{ 'empty-select': isProjectAwardedEmpty }"
                              class="form-control"
                              name="project_awarded"
                              @change="handleChange('project_awarded')">
                                <option selected value class="empty-option">Select an option</option>
                                <option
                                  v-for="(status, index) in bid_status"
                                  :key="`${status}-${index}`"
                                  :value="status.value">{{ status.label }}</option>
                            </select>
                            <button
                              ref="project_awarded-clear-button"
                              v-if="selected.project_awarded"
                              class="clear-button close"
                              type="button"
                              @click.prevent="handleClearBtn('project_awarded')"><span>×</span></button>
                        </div>
                    </div>
                    <div class="row">
                        <div class="form-group col-md-12 col-xs-12 col-lg-12">
                            <label>SES Proposal:</label>
                            <select
                              ref="awarded_to_ses"
                              v-model="selected.awarded_to_ses"
                              :class="{ 'empty-select': isAwardedToSesEmpty }"
                              class="form-control"
                              name="awarded_to_ses"
                              @change="handleChange('awarded_to_ses')">
                                <option selected value class="empty-option">Select an option</option>
                                <option
                                  v-for="(status, index) in ses_proposal_status"
                                  :key="`${status}-${index}`"
                                  :value="status.value">{{ status.label }}</option>
                            </select>
                            <button
                              ref="awarded_to_ses-clear-button"
                              v-if="selected.awarded_to_ses"
                              class="clear-button close"
                              type="button"
                              @click.prevent="handleClearBtn('awarded_to_ses')"><span>×</span></button>
                        </div>
                    </div>
                    <div class="row">
                        <div class="form-group col-md-12 col-xs-12 col-lg-12">
                            <label>Reason:</label>
                            <select
                              ref="job_lost_reason"
                              v-model="selected.job_lost_reason"
                              :class="{ 'empty-select': isJobLostReasonEmpty }"
                              class="form-control"
                              name="job_lost_reason"
                              @change="handleChange('job_lost_reason')">
                                <option selected value class="empty-option">Select an option</option>
                                <option
                                  v-for="(status, index) in reason_status"
                                  :key="`${status}-${index}`"
                                  :value="status.value">{{ status.label }}</option>
                            </select>
                            <button
                              ref="job_lost_reason-clear-button"
                              v-if="selected.job_lost_reason"
                              class="clear-button close"
                              type="button"
                              @click.prevent="handleClearBtn('job_lost_reason')"><span>×</span></button>
                        </div>
                    </div>
                    <div class="row">
                        <div class="form-group col-md-12 col-xs-12 col-lg-12">
                            <label>Pending Close:</label>
                            <select
                              ref="pending_close"
                              v-model="selected.pending_close"
                              :class="{ 'empty-select': isPendingCloseEmpty }"
                              class="form-control"
                              name="pending_close"
                              @change="handleChange('pending_close')">
                                <option selected value class="empty-option">Select an option</option>
                                <option
                                  v-for="(status, index) in pending_close_status"
                                  :key="`${status}-${index}`"
                                  :value="status.value">{{ status.label }}</option>
                            </select>
                            <button
                              ref="pending_close-clear-button"
                              v-if="selected.pending_close"
                              class="clear-button close"
                              type="button"
                              @click.prevent="handleClearBtn('pending_close')"><span>×</span></button>
                        </div>
                    </div>
                </div>
            </div>
          </form>
          <template>
            <hr style="margin-top: 3px; margin-bottom: 5px;">
            <div style="min-height: 305px; max-height: 305px; margin-bottom: 5px;">
              <h4 style="color: black;">
                <template v-if="!isAddingNote">Notes</template>
                <template v-else-if="isAddingNote && !toAddNote.id">Add Note</template>
                <template v-else>Edit Note</template>
                <a v-if="!isAddingNote && !isLoadingNotes && !isLoading" style="float: right;" class="btn btn-black custom" @click="handleAddNote">Add Note</a>
              </h4>
              <div class="clearfix"></div>
              <template v-if="isLoadingNotes || isLoading">
                <div class="row">
                  <div class="col-md-12">
                      <div class="skeleton-progress progress" style="height: 3em;">
                          <div class="progress-bar progress-bar-striped progress-bar-animated" style="width: 100%;"></div>
                      </div>
                  </div>
                </div>
              </template>
              <template v-else>
                <div v-if="!isAddingNote" class="table-wrapper-scroll-y my-custom-scrollbar">
                  <table class="survey_note_table">
                    <tbody>
                      <tr>
                        <td style="width: 25%">Date</td>
                        <td style="width: 65%">Note</td>
                        <td style="width: 10%">&nbsp;</td>
                      </tr>
                      <template v-if="notes.length < 1">
                        <tr>
                          <td colspan="3">No Notes Found</td>
                        </tr>
                      </template>
                      <template v-else>
                        <tr v-for="note in notes" :key="note.id">
                          <td>{{ note.date }}</td>
                          <td>{{ note.detail }}</td>
                          <td>
                            <a class="js-item-edit" @click="editNote(note)"><i class="fa fa-edit"></i></a>
                          </td>
                        </tr>
                      </template>
                    </tbody>
                  </table>
                </div>
                <form ref="addNoteForm" v-else class="add-note-form" autocomplete="off" @submit.prevent="handleSubmitNote">
                  <div class="col-md-12">
                    <div class="row">
                      <div class="form-group col-md-12 col-xs-12 col-lg-12">
                        <label>Date: <span class="required-indicator">*</span></label>
                        <date-picker
                          ref="note_date"
                          v-model="toAddNote.date"
                          :input-attr="{ required: 'required', ref: 'note_date' }"
                          :value-type="'format'"
                          :clearable="false"
                          type="date"
                          required
                          @change="handleChange('note_date')"></date-picker>
                      </div>
                    </div>
                    <div class="row">
                      <div class="form-group col-md-12 col-xs-12 col-lg-12">
                        <label>Detail: <span class="required-indicator">*</span></label>
                        <textarea
                          ref="note_detail"
                          v-model="toAddNote.detail"
                          rows="4"
                          style="resize: none; margin-bottom: -4px; width: 100%;"
                          name="notes"
                          required
                          maxlength="100"
                          @change="handleChange('note_detail')"></textarea>
                      </div>
                    </div>
                  </div>
                </form>
                <div style="margin-top: 10px; float: right;">
                  <template v-if="isAddingNote">
                    <a :disabled="isSavingNote" class="btn btn-black custom" @click="handleCancelNote">Cancel</a>
                    <a class="btn btn-black custom" style="margin-right: 15px;" @click="handleSubmitNote">
                      <template v-if="isSavingNote"><span class="fa fa-spinner fa-pulse"></span> Saving</template>
                      <template v-else>Save Note</template>
                    </a>
                  </template>
                </div>
                <div class="clearfix"></div>
              </template>
            </div>
          </template>
        </template>
        <template slot="footer">
          <template>
            <a :disabled="isSaving || isSavingNote" class="btn btn-black" @click="handleClose">Cancel</a>
            <a :disabled="isSaving || isSavingNote" class="btn btn-black" @click="handleClickSave">
              <template v-if="isSaving"><span class="fa fa-spinner fa-pulse"></span> Saving</template>
              <template v-else>Save Response</template>
            </a>
          </template>
        </template>
    </modal>
</template>
<script>
  import DatePicker from 'vue2-datepicker';
  import 'vue2-datepicker/index.css';
  export default {
  components: { DatePicker },
    name: 'ResponseModal',
    props: {
      proposal: {
        type: Object,
        required: true
      }
    },
    data() {
      return {
        saving: false,
        editable: false,
        isLoading: false,
        isAddingNote: false,
        isLoadingNotes: false,
        toAddNote: {
          date: '',
          detail: ''
        },
        isSavingNote: false,
        notes: [],
        selected: {
          project_awarded: '',
          awarded_to_ses: '',
          job_lost_reason: '',
          pending_close: this.proposal.pending_close
        },
        isSaving: false,
        bid_status: [
          {
            value: 'won',
            label: 'Won'
          },
          {
            value: 'lost',
            label: 'Lost'
          },
          {
            value: 'pending',
            label: 'Pending'
          }
        ],
        ses_proposal_status: [
          {
            value: 'yes',
            label: 'Won'
          },
          {
            value: 'no',
            label: 'Lost'
          }
        ],
        reason_status: [
          {
            value: 'Consultant Spec',
            label: 'Consultant Spec'
          },
          {
            value: 'Price',
            label: 'Price'
          },
          {
            value: 'Fitment',
            label: 'Fitment'
          },
          {
            value: 'Other',
            label: 'Other'
          }
        ],
        pending_close_status: [
          {
            value: 'Yes',
            label: 'Yes'
          },
          {
            value: 'No',
            label: 'No'
          }
        ],
        errors: {}
      }
    },
    computed: {
      isProjectAwardedEmpty: function() {
        return this.selected.project_awarded === '' || this.selected.project_awarded === null
      },
      isAwardedToSesEmpty: function() {
        return this.selected.awarded_to_ses === '' || this.selected.awarded_to_ses === null
      },
      isJobLostReasonEmpty: function() {
        return this.selected.job_lost_reason === '' || this.selected.job_lost_reason === null
      },
      isPendingCloseEmpty: function() {
        return this.selected.pending_close === '' || this.selected.pending_close === null
      }
    },
    created() {
      this.getAnswers()
    },
    methods: {
      handleEditResponse() {
        this.editable = true
      },
      getAnswers() {
        this.isLoading = true
        this.$http.get(`/api/projects/${this.proposal.id}/note-detail`).then((response) => {
          this.selected.project_awarded = (response.data.project_awarded) ? response.data.project_awarded : ''
          this.selected.awarded_to_ses = (response.data.awarded_to_ses) ? response.data.awarded_to_ses : ''
          this.selected.job_lost_reason = (response.data.job_lost_reason) ? response.data.job_lost_reason : ''
          this.notes = (Array.isArray(response.data.notes)) ? response.data.notes : []
          this.isLoading = false
        }).catch((error) => {
          console.log(error)
          this.isLoading = false
        })
      },
      saveResponse() {
        this.isSaving = true
        this.$http.put(`/api/projects/${this.proposal.id}/note-detail`, this.selected).then(() => {
          this.editable = false
          this.isSaving = false
          this.handleUpdated()
        }).catch(error => {
          this.isSaving = false
          if (error.response.data.message === 'validation_error') {
            alert('Please fill all required data.');
          }
        })
      },
      handleClickSave() {
        // if ( !this.checkData('responseCodeForm') ) return false;
        if (this.selected.project_awarded !== '' && this.selected.project_awarded !== null && this.selected.project_awarded !== undefined) {
          this.saveResponse();
        }
      },
      handleClose() {
        this.$emit('close')
        this.selected = {
          project_awarded: '',
          awarded_to_ses: '',
          job_lost_reason: '',
          pending_close: ''
        }
      },
      handleUpdated() {
        this.$emit('updated');
        this.selected = {
          project_awarded: '',
          awarded_to_ses: '',
          job_lost_reason: '',
          pending_close: ''
        };
      },
      checkData(ref){
        let hasEmpty = false,
          firstEl = false;

        const length = this.$refs[ref].elements.length;
        for (let i = 0; i <= length - 1; i++) {
          const el = this.$refs[ref].elements[i];
          if (el.required && (el.value === '' || el.value === undefined)) {
            hasEmpty = true;
            if ( !firstEl ) firstEl = el;
            el.classList.add('has-error');
          } else {
            if (el.classList.contains('has-error')) {
              el.classList.remove('has-error');
            }
          }
        }

        if ( hasEmpty ) {
          alert('Please fill all required data.');
          firstEl.focus();
          return false;
        }
        return true;
      },
      handleChange(ref) {
        const el = (ref === 'note_date') ? this.$refs.addNoteForm.elements[0] : this.$refs[ref];
        if (el.required && (el.value !== '' || el.value !== undefined)) {
          if (el.classList.contains('has-error')) {
            el.classList.remove('has-error');
          }
        }
      },
      handleAddNote() {
        this.isAddingNote = true
      },
      getSurveyNotes() {
        this.isLoadingNotes = true
        this.$http.get(`/api/projects/${this.proposal.id}/notes`)
        .then((response) => {
          this.notes = response.data.notes
          this.isLoadingNotes = false
        })
        .catch((error) => {
          console.log(error)
          this.isLoadingNotes = false
        });
      },
      handleSubmitNote() {
        this.isSavingNote = true
        if ( !this.checkData('addNoteForm') ) {
          this.isSavingNote = false;
          return false;
        }
        this.$http.put(`/api/projects/${this.proposal.id}/notes`, this.toAddNote)
          .then(() => {
            this.getSurveyNotes()
            this.isAddingNote = false
            this.isSavingNote = false
            this.toAddNote = {
              date: '',
              detail: ''
            }
          }).catch(error => {
            console.log(error)
            this.isSavingNote = false
            if (error.response.data.message === 'validation_error') {
              alert('Please fill all required data.');
            }
          })
      },
      handleCancelNote() {
        this.toAddNote = Object.assign({}, {
          date: '',
          detail: ''
        })
        this.isAddingNote = false
      },
      editNote(note) {
        this.toAddNote = Object.assign({}, note)
        this.isAddingNote = true
      },
      handleClearBtn(btn) {
        this.selected[btn] = ''
      }
    }
  }
</script>
<style>
  table td {
    padding: 3px;
  }
  .response-code-form .has-error{
    outline: 1px solid red !important;
    z-index: 2 !important;
    background: #ffe9e9 !important;
    border-color: red !important;
  }
  .add-note-form .has-error{
    outline: 1px solid red !important;
    z-index: 2 !important;
    background: #ffe9e9 !important;
    border-color: red !important;
  }
  .survey_note_table { width: 100%; margin-top: 5px; margin-bottom: 1px;}
  .survey_note_table tr:first-child { font-weight: bold; font-size: 15px; }
  .survey_note_table td { border: 1px solid #d2d2d2; text-align: left; }
  .survey_note_table td:last-child { text-align: center !important; }
  .survey_note_table td:first-child { text-align: center !important; }
  .btn.btn-black.custom { padding: 3px 17px; }
  .js-item-edit { background: gray; color: #FFF !important; padding: 2px 8px; display: inline-block; border-radius: 3px; cursor: pointer; border: 1px solid gray; }
  .my-custom-scrollbar {
    position: relative;
    height: 260px;
    overflow-y: auto;
  }
  .table-wrapper-scroll-y {
    display: block;
  }
  .clear-button {
    position: absolute;
    top: 30px;
    border-radius: 10px;
    right: 40px;
    z-index: 2;
    border: none;
    height: 20px;
    cursor: pointer;
    color: black;
    background-color: #d4dadf !important;
    transform: translateX(2px);
    width: 20px;
    font-weight: bold;
    padding-top: 2px !important;
  }
  .empty-select {
    color: grey !important;
  }
  .empty-select > option:not(:first-child) {
    color: black !important;
  }
  .empty-option {
    color: grey !important;
  }
</style>